import { Stack, TableCell, TableRow, Tooltip, useTheme } from '@mui/material'
import VirtualizedTable from '../../../../common/virtualisedTable'

const WithPaymentTypeTable = ({ loginData, selBranch, selDestCity, selFromBranch, columnDefs, tableData }) => {
  const theme = useTheme()
  const { tableHeaderColor } = theme
  const updateTableData = tableData.map((row) => {
    return row.dataType === 'entry'
      ? {
          ...row,
          OnlyLRNo: `${row.LRNO}\n${row.VoucherNo}\n${row.ManualLR}`,
          BookCity: (
            <Tooltip title={row.BookCity} placement="top-start">
              <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>{row.BookCity}</span>
            </Tooltip>
          ),
          ToCity: (
            <Tooltip title={row.ToCity} placement="top-start">
              <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>{row.ToCity}</span>
            </Tooltip>
          ),
          DispatchedToCityFilter: (
            <Tooltip title={row.DispatchedToCityFilter} placement="top-start">
              <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                {row.DispatchedToCityFilter}
              </span>
            </Tooltip>
          ),
          DispatchedToBranchFilter: (
            <Tooltip title={row.DispatchedToBranchFilter} placement="top-start">
              <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                {row.DispatchedToBranchFilter}
              </span>
            </Tooltip>
          ),
          SenderName: (
            <>
              <Tooltip title={row.SenderName} placement="top-start">
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                  {row.SenderName}
                </span>
              </Tooltip>
              <Tooltip title={row.SenderMobileNo} placement="top-start">
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                  {row.SenderMobileNo}
                </span>
              </Tooltip>
              <Tooltip title={row.SenderGSTN} placement="top-start">
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                  {row.SenderGSTN}
                </span>
              </Tooltip>
              <Tooltip title={row.SenderEmailID} placement="top-start">
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                  {row.SenderEmailID}
                </span>
              </Tooltip>
            </>
          ),
          RecName: (
            <>
              <Tooltip title={row.RecName} placement="top-start">
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>{row.RecName}</span>
              </Tooltip>
              <Tooltip title={row.RecMobileNo} placement="top-start">
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                  {row.RecMobileNo}
                </span>
              </Tooltip>
              <Tooltip title={row.ReceiverGSTN} placement="top-start">
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                  {row.ReceiverGSTN}
                </span>
              </Tooltip>
              <Tooltip title={row.ReceiverEmailID} placement="top-start">
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                  {row.ReceiverEmailID}
                </span>
              </Tooltip>
            </>
          ),
          ItemDetails: (
            <Tooltip title={row.ItemDetails} placement="top-start">
              <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                {row.ItemDetails}
              </span>
            </Tooltip>
          ),
        }
      : row
  })
  const headerContent = () => {
    return (
      <>
        <TableRow style={{ backgroundColor: '#bfe1ff', color: '#444444' }}>
          <TableCell
            className="reportTD"
            style={{ fontSize: '12px', fontWeight: '600', textAlign: 'left', color: '#444444', height: '36px' }}
            colSpan={Math.floor(columnDefs?.length / 3)}
          >
            Dispatch By Branch: {selFromBranch?.name || loginData?.strBranchName}
          </TableCell>
          <TableCell
            className="reportTD"
            style={{ fontSize: '12px', fontWeight: '600', textAlign: 'center', color: '#444444' }}
            colSpan={Math.floor(columnDefs?.length / 3)}
          >
            Destination City: {selDestCity?.name}
          </TableCell>

          <TableCell
            className="reportTD"
            style={{ fontSize: '12px', fontWeight: '600', textAlign: 'right', color: '#444444' }}
            colSpan={columnDefs.length - Math.floor(columnDefs?.length / 3) * 2}
          >
            Destination Branch: {selBranch?.name}
          </TableCell>
        </TableRow>
        <TableRow>
          {columnDefs.map((item) => {
            return (
              <TableCell
                style={{
                  ...item?.headerSx,
                  backgroundColor: '#e5f3ff',
                  color: '#444',
                  fontSize: '12px',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  fontWeight: '600',
                  whiteSpace: 'pre-line',
                  verticalAlign: 'top',
                }}
                colSpan={1}
              >
                {item?.header}
              </TableCell>
            )
          })}
        </TableRow>
      </>
    )
  }

  const bodyContent = (index, obj) => {
    return <DisPatchBody row={obj} index={index} tableHeaderColor={tableHeaderColor} columnDefs={columnDefs} />
  }
  return (
    <Stack sx={{ marginLeft: 2, marginRight: 2, paddingTop: '10px', paddingBottom: '16px' }} className="vehicle-wise-table-box">
      <VirtualizedTable
        tableData={updateTableData}
        headerContent={headerContent}
        rowContent={bodyContent}
        tableStyle={{ tableLayout: 'auto', width: '100%' }}
        autoResize={true}
      />
    </Stack>
  )
}
const DisPatchBody = ({ row, index, tableHeaderColor, columnDefs }) => {
  if (!row?.dataType) return null
  const getStyles = (field, align) => {
    const common = {
      minHeight: '36px',
      fontSize: '12px',
      color: '#444',
    }
    if (row.dataType === 'entry') {
      return {
        ...common,
        fontWeight: '500',
        textAlign: align || 'left',
      }
    }
    if (row.dataType === 'subHeader') {
      return {
        ...common,
        fontWeight: '600',
        backgroundColor: tableHeaderColor?.isSubHeadingColor,
        textAlign: row.align?.[field] || 'left',
        position: 'sticky',
        top: '80px',
      }
    }
    if (row.dataType === 'total') {
      return {
        ...common,
        fontWeight: '600',
        backgroundColor: tableHeaderColor?.isTotalColor,
        textAlign: row.align?.[field] || 'right',
      }
    }
  }

  return (
    <>
      {(() => {
        let skip = 0
        return columnDefs.map((item, i) => {
          if (skip > 0) {
            skip--
            return null
          }
          const colSpan = row.colSpan?.[item.field] || 1
          skip = colSpan - 1
          return (
            <TableCell className="reportTD" key={item.field + i + index} colSpan={colSpan} style={getStyles(item.field, item.textAlign)}>
              {row[item.field]}
            </TableCell>
          )
        })
      })()}
    </>
  )
}

export default WithPaymentTypeTable